import React from 'react';
import PropTypes from 'prop-types';
import Raven from 'raven-js';

import TaskMaterials from 'api/resources/taskMaterials';
import getErrors from 'utils/getErrors';
import { Deserializer } from 'jsonapi-serializer';
import fullname from 'utils/fullname';

import { ReactComponent as IconMaterialStory } from 'icons/MaterialStory.svg';
import StoryItem from 'admin-moderator/components/StoryItem';
import Loader from 'components/Loader';
import DashedButton from 'components/DashedButton';
import LoaderWrapper from 'components/Loader/LoaderWrapper';

import CenteredContainer from 'styled/Page/CenteredContainer';
import ErrorText from 'styled/Page/ErrorText';

const getAvatar = (version) => {
  if (version.user) return version.user.avatar ? version.user.avatar.url : '';
  if (version.employee) return version.employee.avatar ? version.employee.avatar.url : '';

  return '';
};

export class MaterialStory extends React.PureComponent {
  state = {
    loading: false,
    isOpen: false,
    errors: [],
    versions: [],
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.isOpen !== prevState.isOpen && this.state.isOpen) {
      this.loadVersions();
    }
  }

  handleStoryToggle = () => {
    this.setState(prevState => ({ isOpen: !prevState.isOpen }));
  };

  loadVersions = async () => {
    this.setState({
      loading: true,
      versions: [],
      errors: [],
    });

    try {
      const response = await TaskMaterials.getVersions({
        materialId: this.props.id,
        include: 'user,user.avatar,user.oauth_providers,employee,employee.avatar',
        fields: {
          version: 'user,employee,object_changes,created_at,event',
          user: 'first_name,last_name,avatar,oauth_providers',
          employee: 'first_name,last_name,avatar,roles',
        },
      });

      const versions = await new Deserializer({ keyForAttribute: 'camelCase' }).deserialize(response);

      this.setState({
        versions,
        loading: false,
      });
    } catch (err) {
      this.setState({ errors: await getErrors(err), loading: false });

      Raven.captureException(err, { extra: this.props });
    }
  }

  render() {
    return (
      <div style={{ marginTop: '25px' }}>
        <DashedButton
          onClick={this.handleStoryToggle}
          disabled={this.state.loading}
          icon={<IconMaterialStory />}
        >
          {this.state.isOpen ? 'Скрыть историю по материалу' : 'Показать историю по материалу'}
        </DashedButton>

        {this.state.loading && (<LoaderWrapper><Loader /></LoaderWrapper>)}

        {this.state.isOpen && (
          <React.Fragment>
            {this.state.versions.length > 0 && (
              <div style={{ margin: '24px 0', borderTop: '1px solid rgba(255, 255, 255, 0.1)' }}>
                {this.state.versions.map(version => (
                  <StoryItem
                    key={version.id}
                    name={version.user ? fullname(version.user) : fullname(version.employee)}
                    roles={version.employee ? version.employee.roles : undefined}
                    socialLinks={version.user ? version.user.oauthProviders : undefined}
                    avatarUrl={getAvatar(version)}
                    objectChanges={version.objectChanges}
                    updatedAt={version.createdAt}
                    event={version.event}
                  />
                ))}
              </div>
            )}

            {this.state.errors.length === 0 && !this.state.loading && this.state.versions.length === 0 && (
              <CenteredContainer>
                История по материалу пуста
              </CenteredContainer>
            )}

            {this.state.errors.length > 0 && (
              <CenteredContainer>
                {this.state.errors.map(error => (
                  <ErrorText role="alert" key={error}>{error}</ErrorText>
                ))}
              </CenteredContainer>
            )}
          </React.Fragment>
        )}
      </div>
    );
  }
}

MaterialStory.propTypes = {
  id: PropTypes.string.isRequired,
};

export default MaterialStory;
